<phx-input-group
  [phxAddOnBefore]="domainList.length > 1 ? addOnBeforeDynamic : singleDomainAddOn"
  [phxSuffix]="phxSuffix"
  [phxDropdownFor]="omniFilterDropdown"
  phxDropdownClassName="phx-omnifilter-dropdown-panel"
  [phxDropdownWidth]="triggerWidth"
  [phxTrigger]="null"
  [phxVisible]="isDropdownOpen"
  [phxBackdrop]="false"
  #dropdownTrigger
>
  <input
    class="phx-omnifilter-input"
    #omnifilterInput
    phx-input
    [placeholder]="placeholderText"
    [ngModel]="phxInputValue"
    [disabled]="phxDisabled"
    (input)="debouncedHandleInput($event)"
    (focus)="onFocus()"
    (keydown)="onInputKeyDown($event)"
    (click)="onInputClick()"
  />
</phx-input-group>

<phx-dropdown #omniFilterDropdown>
  <div class="phx-omnifilter-dropdown phx-web-type-default" (keydown)="onKeyDown($event)" #dropdownContainer>
    <div *ngIf="combinedTokens.length > 0 && phxMultiple">
      <div class="phx-omnifilter-tokens-container">
        <ng-container *ngTemplateOutlet="token"></ng-container>
      </div>
    </div>
    <div class="phx-omnifilter-keyword-container" *ngIf="!!phxInputValue && phxShowFindByKeyword">
      <div
        class="phx-omnifilter-keyword"
        [class.phx-omnifilter-keyword-focused]="isKeywordHighlighted"
        (click)="onFindByKeywordClick(phxInputValue)"
        (mouseenter)="onKeywordSearchMouseEnter()"
        phxOmnifilterFocusableDirective="findByKeyword"
        tabIndex="-1"
        (keydown.enter)="onFindByKeywordClick(phxInputValue)"
      >
        <i phx-icon [phxIcon]="MagnifyingGlass" color="currentColor"></i>
        <div>
          <span class="phx-web-type-default">{{'Keyword' | phxTranslate}} </span> <span class="phx-omnifilter-keyword-text phx-web-type-default-emphasis">"{{ phxInputValue }}"</span>
        </div>
      </div>
    </div>
    <div *ngIf="phxLoading" class="phx-omnifilter-loader-container">
      <phx-spinner [phxCentered]="true" phxSize="large"></phx-spinner>
    </div>
    <ng-container *ngIf="!phxLoading">
      <div
        class="phx-omnifilter-info-boxes"
        [class.phx-omnifilter-quick-select-border]="quickOptions.length > 0"
        *ngIf="selectedDomain && !phxInputValue && phxOptions.length === 0"
      >
        <span class="phx-web-type-default">{{ findByString }}</span>
      </div>
      <div class="phx-omnifilter-info-boxes" *ngIf="phxInputValue && phxInputValue.length > 1 && phxOptions.length === 0">
        <div *ngIf="!isInputMatchingSelectedOption" class="phx-web-type-default-emphasis">{{'No matches found' | phxTranslate}}</div>
        <div class="phx-web-type-default">{{ findByString }}</div>
      </div>
      <div class="phx-omnifilter-quick-select-container" *ngIf="quickOptions.length > 0 && !phxInputValue">
        <phx-selection-list
          [phxAllowClear]="false"
          [phxServerSearch]="true"
          [phxOptimisticSelection]="true"
          [phxDontTrapFocus]="true"
          [phxPreventSelection]="phxNavigateOnEntityClick"
          [phxOptions]="quickOptions"
          [phxMultiple]="phxMultiple"
          [phxSearchText]="phxInputValue"
          [phxShowFirstOptionFocused]="!(phxShowFindByKeyword && phxInputValue)"
          [ngModel]="selectedQuickOptions"
          (ngModelChange)="onQuickSelectionChange($event)"
          (mouseenter)="onSelectionListMouseInteraction()"
          phxOmnifilterFocusableDirective="selection-list"
        ></phx-selection-list>
        <phx-divider *ngIf="quickOptions.length > 0 && phxOptions.length > 0" phxMarginY="none"></phx-divider>
      </div>

      <phx-selection-list
        *ngIf="phxOptions.length > 0"
        [phxAllowClear]="false"
        [phxServerSearch]="true"
        [phxShowSubText]="true"
        [phxHighlightSubtext]="true"
        [phxOptimisticSelection]="true"
        [phxDontTrapFocus]="true"
        [phxPreventSelection]="phxNavigateOnEntityClick"
        [phxListHeight]="360"
        [phxOptions]="phxOptions"
        [phxMultiple]="phxMultiple"
        [phxSearchText]="phxInputValue"
        [phxShowFirstOptionFocused]="!phxShowFindByKeyword"
        [ngModel]="selectedOptions"
        (ngModelChange)="onRegularSelectionChange($event)"
        (phxScrollEnd)="onScrollEnd()"
        (mouseenter)="onSelectionListMouseInteraction()"
        phxOmnifilterFocusableDirective="selection-list"
      ></phx-selection-list>
    </ng-container>
    <ng-container *ngIf="shouldShowFooter">
      <ng-container *ngTemplateOutlet="omniFilterFooter"></ng-container>
    </ng-container>
  </div>
</phx-dropdown>

<ng-template #phxSuffix>
  <span class="phx-omnifilter-input-suffix">
    <i
      phx-icon
      *ngIf="phxMultiple ? hasInput : (combinedTokens.length > 0 || hasInput)"
      class="phx-omnifilter-input-clear-icon"
      (keydown.enter)="onCrossClick()"
      (click)="onCrossClick()"
      [phxIcon]="CrossIcon"
      [size]="20"
      [disabled]="phxDisabled"
      tabindex="0"
    ></i>
    <phx-divider
      class="phx-omnifilter-divider-input"
      *ngIf="phxMultiple && hasInput && combinedTokens.length > 0"
      phxMarginX="small-medium"
      [phxOrientation]="'vertical'"
      phxDividerHeight="auto"
    ></phx-divider>
  </span>
  <div *ngIf="phxMultiple && combinedTokens?.length" class="phx-omnifilter-input-suffix-badge-container">
    <phx-badge [phxShowZero]="true" phx-tooltip [phxContent]="tooltipTemplate" class="phx-omnifilter-badge" [phxCount]="combinedTokens?.length" [phxDismissible]="true" [disabled]="phxDisabled" [phxTrigger]="combinedTokens?.length > 0 ? 'hover' : 'none'" (phxDismissedChange)="clearSelections()">
    </phx-badge>
    <ng-template #tooltipTemplate>
      <span class="phx-web-type-body-medium">
          <span>{{tooltipContent}}</span>
          <br />
          <span *ngIf="combinedTokens?.length > MaximumTooltipOptionsToShow" class="phx-omnifilter-badge-tooltip-more">
            {{'+' | phxTranslate}}{{combinedTokens?.length - MaximumTooltipOptionsToShow}} {{'more' | phxTranslate}}
          </span>
      </span>
    </ng-template>
  </div>
</ng-template>


<ng-template #omniFilterFooter>
  <div class="phx-omnifilter-footer">
    <div class="phx-omnifilter-footer-group-toggler" *ngIf="shouldShowGroupByOption">
      <span class="phx-omnifilter-footer-toggler-text phx-web-type-body-medium">{{'Group results' | phxTranslate}}</span>
      <phx-toggle [phxSwitch]="true" phxSize="small" [(ngModel)]="phxShowByType" (ngModelChange)="onToggleChange($event)" phxOmnifilterFocusableDirective="toggle" tabindex="-1"></phx-toggle>
    </div>
    <div class="phx-omnifilter-footer-deactivated-toggler" *ngIf="phxShowDeactivatedToggle">
      <span class="phx-omnifilter-footer-toggler-text phx-web-type-body-medium">{{deactivatedEntitesMessage}}</span>
      <phx-toggle [phxSwitch]="true" phxSize="small" [(ngModel)]="phxShowDeactivatedEntities" (ngModelChange)="onShowDeactivatedEntitiesChange($event)" phxOmnifilterFocusableDirective="toggle" tabindex="-1"></phx-toggle>
    </div>
  </div>
</ng-template>

<ng-template #addOnBeforeDynamic>
  <phx-select
    phxDropdownWidth="auto"
    [phxTriggerTemplate]="triggerTemplate"
    [phxAllowClear]="false"
    [disabled]="phxDisabled"
    [(ngModel)]="selectedDomainItem"
    (ngModelChange)="onDomainSelect($event)"
    tabindex="-1"
  >
    <phx-select-option
      *ngFor="let domain of domainList"
      [value]="domain.name"
      [label]="domain.label"
      [data]="domain"
      [prefixIcon]="domain.icon"
    ></phx-select-option>
  </phx-select>

  <ng-template #triggerTemplate>
    <phx-addon [phxDisabled]="phxDisabled">
      <i phx-icon [phxIcon]="selectedDomain?.icon"></i>
      <i phx-icon [phxIcon]="ChevronUpDown" [size]="16"></i>
    </phx-addon>
  </ng-template>
</ng-template>

<ng-template #singleDomainAddOn>
  <phx-addon [phxDisabled]="phxDisabled">
    <i phx-icon [phxIcon]="selectedDomain?.icon"></i>
  </phx-addon>
</ng-template>

<ng-template #token>
  <span *ngFor="let token of combinedTokens" class="phx-omnifilter-token phx-web-type-small" (click)="onTokenRemove(token)" phxOmnifilterFocusableDirective="token" tabindex="-1" (keydown.enter)="tokenRemoveWithKeyboard(token)">
    <span class="phx-omnifilter-token-prefix">
      <i phx-icon [phxIcon]="domainIcon(token.domain)" [size]="16"></i>
    </span>
    <span class="phx-omnifilter-token-text">{{ token.label }}</span>
    <span class="phx-omnifilter-token-suffix">
      <i phx-icon [phxIcon]="CrossIcon" [size]="16"></i>
    </span>
  </span>
  <button phx-button phxSize='small' phxButtonRole="secondary" (phxOnClick)="clearSelections()" (keydown.enter)="clearSelections()" phxOmnifilterFocusableDirective tabindex="-1">{{'Clear' | phxTranslate}}</button>
</ng-template>

<ng-template #deactivatedEntitySuffixTemplate>
  <phx-tag class="phx-omnifilter-deactivated-entity-tag" [phxSize]="'extra-small'">{{'Deactivated' | phxTranslate | uppercase}}</phx-tag>
</ng-template>